import { CCLocalStorageRawDto } from 'cc-common';

export class UserSettingRawDto extends CCLocalStorageRawDto {}
